/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import {
  Typography,
  TableRow,
  TableCell,
  Box,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import CustomAvatar from "src/components/shared/atoms/avatar/customAvatar";
import clsx from "clsx";
import Button from "src/components/shared/atoms/button";
import WhatsAppTemplatesModal from "../templatesModal";
import CallSettingsModal from "../CallSettingsModal";
import useStyle from "./Styles";

interface Props {
  curr: any;
  connectedHandler: any;
  disconnectedHandler: any;
  closeHandler: any;
  loading: boolean;
  disabled: boolean;
  showUpgradePopUp?: any;
  id?: string;
}

const InternalRow: React.FC<Props> = ({
  curr,
  closeHandler,
  connectedHandler,
  disconnectedHandler,
  loading,
  disabled,
  showUpgradePopUp,
  id,
}) => {
  const [templatesOpen, setTemplatesOpen] = useState(false);
  const [callSettingsOpen, setCallSettingsOpen] = useState(false);
  const { classes } = useStyle();

  const isEnabled = curr.disabled !== 2;
  const { isSelected } = curr;

  return (
    <TableRow>
      <TableCell className={classes.rowCell}>
        <Box className={classes.rowContainer}>
          <Box className={clsx(classes.hoverIndicator, "hover-indicator")} />

          <Box className={classes.rowProfileSection}>
            <CustomAvatar
              src={curr.picture}
              alt={curr.name}
              className={classes.avatar}
            />
            <Box className={classes.textContainer}>
              <Typography className={classes.pageName}>{curr.name}</Typography>
              <Typography className={classes.wa_number}>
                {curr.wa_number}
              </Typography>
            </Box>
          </Box>

          <Box className={classes.rowActionSection} id={id}>
            {isSelected && (
              <Button variant="text" handleClick={() => setTemplatesOpen(true)}>
                View Templates
              </Button>
            )}
            {isSelected && (
              <Button
                variant="text"
                handleClick={() => setCallSettingsOpen(true)}
              >
                Call Settings
              </Button>
            )}
            <Button
              variant="text"
              handleClick={
                !isEnabled
                  ? () => showUpgradePopUp(curr)
                  : isSelected
                  ? () => disconnectedHandler(curr)
                  : () => connectedHandler(curr)
              }
              className={clsx(classes.actionButton, {
                [classes.disconnectBtn]: isEnabled && isSelected,
                [classes.connectBtn]: isEnabled && !isSelected,
                [classes.disabledBtn]: !isEnabled,
              })}
              disabled={disabled}
              circular={loading}
            >
              {!isEnabled
                ? "Enable Number"
                : isSelected
                ? "Disconnect"
                : "Connect"}
            </Button>

            <Tooltip title="Remove Record" arrow>
              <IconButton
                onClick={() => closeHandler(curr)}
                className={classes.deleteIconButton}
                size="small"
              >
                <DeleteOutline className={classes.deleteIcon} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </TableCell>
      {templatesOpen && (
        <WhatsAppTemplatesModal
          open={templatesOpen}
          onClose={() => setTemplatesOpen(false)}
          pageId={curr.pageId}
          pageName={curr.name}
          waNumber={curr.wa_number}
        />
      )}
      {callSettingsOpen && (
        <CallSettingsModal
          open={callSettingsOpen}
          onClose={() => setCallSettingsOpen(false)}
          phoneNumberId={curr.pageId}
          businessToken={curr.accesstoken}
          displayName={curr.name}
          waNumber={curr.wa_number}
        />
      )}
    </TableRow>
  );
};

export default InternalRow;
